import { appStorage } from '@shared/utils/storage.js';
import { normalizeTrainingData, normalizeTrainingRecord } from './normalizeTrainingData.js';

// CONTENTS:
//  - updateStorage()

export function updateStorage(user, writeToDB, writeTo, articleID) {
	user.training = normalizeTrainingData(user.training);
	appStorage.set('user', user);
  if (user?._id && writeToDB) { // also push to server if account exists
    var updatedData = {};
    switch (writeTo){
      case 'userProfile':
        updatedData.language = user.preferredLanguage;
        // currently only used to write the preferredLanguage key
        break;

      case 'trainingShares':
        updatedData = { 'shares' : user.trainingShares }
        break;

      case 'trainingData':
        updatedData = { ...user.training };
        break;

      case 'articleStatus':
        updatedData = normalizeTrainingRecord(user.training[articleID]);
        user.training[articleID] = updatedData;
        updatedData['id'] = articleID;
        break;
    }

    if (!Object.keys(updatedData).length) {return;}

    updatedData.type = writeTo;
    console.log(updatedData);

    const pushData = async() => {
      try {
        const response = await fetch('/study/api/setProgress', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updatedData),
        });

        const data = await response.json();
        console.log(response);

        if (!response.ok) {
          throw new Error(data.error || 'Update failed');
        }

        console.log('Storage update succeeded:', data);

      } catch (error) {
        // probably logged out
        console.error('Storage update failed:', error);

        // TODO: write to db which user is bugged

        // flush caches and retry
        Object.keys(user).forEach(key => delete user[key]);
        Object.assign(user, { profile: {} });
        appStorage.set('user', user);

        // retry with cleared storage
        updateStorage(user);
      }
    }
    pushData();
  } // end push to server
}
